module.exports = __webpack_public_path__ + "img/type2_bg1.379a3ee8.png";